// Command catalog dialog for Poppy in Twitch Chat

import React from 'react';
import { Link } from 'react-router';
import {
  POPPY_CHAT_COMMAND_NAMESPACE,
  getPoppyChatCommandRows,
} from '@airhead-games/shared/configs';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { analyticsService } from '@/services/analyticsService';
import type { LibraryDialogOutletProps } from './dialogOutletTypes';

const commandRows = getPoppyChatCommandRows();

const PoppyChatCommandsDialog: React.FC<LibraryDialogOutletProps> = ({
  dialog,
  setDialog,
}) => {
  return (
    <Dialog
      open={dialog === 'chat-commands'}
      onOpenChange={(nextOpen) => setDialog(nextOpen ? 'chat-commands' : null)}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Twitch chat commands</DialogTitle>
          <DialogDescription>
            Anyone in your chat can type{' '}
            <code className="font-medium text-foreground">
              {POPPY_CHAT_COMMAND_NAMESPACE} [command]
            </code>{' '}
            when Respond to commands is on. If no room is open, Poppy says so
            when asked about the room or game.
          </DialogDescription>
        </DialogHeader>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Command</TableHead>
              <TableHead>Info</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {commandRows.map((row) => (
              <TableRow key={row.name}>
                <TableCell>
                  <code>{row.name}</code>
                </TableCell>
                <TableCell className="whitespace-normal">
                  {row.description}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <DialogFooter>
          <Button asChild variant="outline">
            <Link
              to="/discover/features/moderator-tools#poppy-in-twitch-chat"
              onClick={() =>
                analyticsService.trackButtonClick(
                  'learn_more_poppy_chat_commands',
                  {
                    surface: 'library_sidebar',
                    navigation_target:
                      '/discover/features/moderator-tools#poppy-in-twitch-chat',
                    link_location: 'poppy_chat_commands_dialog',
                    link_type: 'internal',
                  }
                )
              }
            >
              Learn more
            </Link>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default PoppyChatCommandsDialog;
